import { cn } from '@cobliteam/ui/utils';
import type React from 'react';

export interface PageFiltersProps {
  children: React.ReactNode;
  className?: string;
}

const PageFilters = ({ children, className }: PageFiltersProps) => {
  return <div className={cn('flex gap-5', className)}>{children}</div>;
};

export default PageFilters;
